<template>
  <div style="max-width: 900px">
    <div class="row ">
<!--      <a class="btn btn-primary mybutton ml-auto" href="#" @click="queryItem(false)">查詢</a>-->
<!--      <a class="btn btn-primary mybutton" href="javascript:location.reload()" >清除搜尋</a>-->
      <a class="btn btn-info mybutton " href="#" @click="addItem">新增</a>
      <a class="btn btn-danger mybutton" href="#" @click="deleteItem">刪除</a>

      <a class="btn btn-info mybutton " href="#" @click="btnExportExcel">匯出excel</a>
    </div>


    <MyGridKendo ref="grid" :columns="gridDefine.columns" :datas="gridDefine.datas" style="width:1024px"></MyGridKendo>
  </div>
</template>

<script>
import {
  QueryType_CheckIn_Index_Test,
} from "../js/checkInDeclare";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import util from "@/util/util";
import MyGridKendo from "@/views/taylorAdmin/component/MyGridKendo";
/**

 **/

let editRouter="CheckInAdminCrudEdit";

export default {
  components: {MyGridKendo},
  //name: "Index",
  // props: [""],
  data: function () {
    return {
      QueryType_CheckIn_Index_Test:QueryType_CheckIn_Index_Test,
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      gridDefine:{
        columns: [
          // { field: 'SystemId', title: 'SystemId', minWidth: 50, width: '50px'},
          { field: 'fun', title: '功能' ,width:100, filterable:false, cell: this.cellFunctionLink},
          { field: 'LoginId', title: '登入帳號' ,width:200},
          { field: 'Name', title: '姓名' ,width:200},
          { field: 'Email', title: 'Email' ,width:300},
          { field: 'Tel', title: '電話' ,width:100},
          //other minWidth: 100,filterable:false
        ],
        datas:[],
      },
    };
  },
  methods: {
    cellFunctionLink: function (h, tdElement , props, clickHandler ) {  // eslint-disable-line
      let that=this;
      let clickFun=function(){
        // that.gotoWithSystemId('MemberEdit',props.dataItem.SystemId)
        that.editItem(props.dataItem.SystemId);
      }

      //---------------------------------------
      return h('td', {
        on: {
          click: function(e){// eslint-disable-line
            clickFun();
          }
        },
        domProps: {
          innerHTML: '<a class="btn btn-primary" href="#"><i class="fa fa-pen"></i></a>'
        }
      });
    },
    async loadData() {
      let data=await apiAdmin.getContentList(this.QueryType_CheckIn_Index_Test);
      this.gridDefine.datas=apiAdmin.initReturnArray(data.data.data);
      // this.$refs.grid.refreshTableData(this.gridDefine.datas);
    },
    renderFunctionButton({ row, column, rowIndex },h) {  // eslint-disable-line
      return (
          <a role="button" class="btn btn-primary" on-click={() => this.editItem(row, column, rowIndex)}>編輯</a>

      );
    },
    addItem(){
      this.$router.push({ name: editRouter, query: { type: this.QueryType_CheckIn_Index_Test,SystemId:"" } })
    },
    editItem (systemId) {// eslint-disable-line
      this.$router.push({ name: editRouter, query: { type: this.QueryType_CheckIn_Index_Test,systemId } });
    },
    deleteItem(){
      let ids=this.$refs.grid.selectedItemsSystemIds();

      if (ids.length>0){
        if (confirm('確定刪除?')){
          apiAdmin.api_deleteContentBySystemIds(ids).then(()=>{
            this.loadData();
          });
        }
      }else{
        util.ShowMessage('請先選擇欲刪除的資料');
      }
    },
    btnExportExcel(){
      this.$refs.grid.exportExcel();
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>

</style>
